import { render, staticRenderFns } from "./position-level.vue?vue&type=template&id=8574f11a&scoped=true"
import script from "./position-level.logic.js?vue&type=script&lang=js&external"
export * from "./position-level.logic.js?vue&type=script&lang=js&external"
import style0 from "./position-level.vue?vue&type=style&index=0&id=8574f11a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8574f11a",
  null
  
)

export default component.exports